export const DefaultItemsToShow: number = 5;
export const MoreMenuItemId: string = 'More';
export const itemWithInternalUrls: Set<string> = new Set(['dcCreateCase']);
